/**
 * Normalized API root (no trailing slash). Set via REACT_APP_API_URL at build/start time.
 * Examples: http://localhost:5000/api, https://bckend.shpax.sharpenax.com/api, /api
 */
export const API_BASE_URL = (process.env.REACT_APP_API_URL || "")
  .trim()
  .replace(/\/+$/, "");
